import { render, staticRenderFns } from "./FooterAffiliations.vue?vue&type=template&id=0bad99c0&"
import script from "./FooterAffiliations.vue?vue&type=script&lang=js&"
export * from "./FooterAffiliations.vue?vue&type=script&lang=js&"
import style0 from "./FooterAffiliations.vue?vue&type=style&index=0&id=0bad99c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports